import React, { createContext, useContext, useState, useEffect } from 'react';
import {useLocation} from "react-router-dom";
import {syncTelemetryContext} from "../helpers/newrelic";

// Regex used to match the path for firing navigation events
const lessonListPath = /^.*\/embeddable\/lessonsList$/
const lessonPath = /^.*\/embeddable\/catchupId\/1\/lesson\/(\d+)(\/(\d+))*$/

export const AppGlobalConfigContext = createContext({
    isEmbedMode:false,
    setEmbedMode: (b) => {},
    fireNavigationEvents: (path, pageName) => {},
    batch: null,
    setBatchData: (b) => {}
}); // Default to non-embeddable

export function AppGlobalConfigProvider({ children }) {
    const [isEmbedMode, setIsEmbedMode] = useState(false);
    const [batch, setBatch] = useState();

    const location = useLocation();

    useEffect(() => {

        if(location) {
            const path = location.pathname;
            const isEmbedPath = path.includes('embeddable'); // Check for path
            const isInIframe = window.self !== window.top;   // Check for iframe embedding
            setIsEmbedMode(isEmbedPath || isInIframe);
        }
    }, [location]); // Re-run

    // Keeps the New Relic telemetry attributes in sync with the current route/context.
    // The route/iframe check avoids reporting "standalone" before isEmbedMode is updated.
    useEffect(() => {
        if (!location) return;
        const path = location.pathname;
        syncTelemetryContext({
            isEmbedMode: isEmbedMode || path.includes('embeddable') || window.self !== window.top,
            pathname: path,
        });
    }, [location, isEmbedMode]);

    const setEmbedMode = (b) => {
        setIsEmbedMode(b);
    }

    const setBatchData = (b) => {
        setBatch(b);
    }

    const postMessageToParent = (message) => {
        window.parent.postMessage(message, "*");
    }

    const postPageChangeEvent = (page, pageName) => {
        const href = window.location.href;
        postMessageToParent({event: 'pageChange', page: page, currentPageTitle: pageName, href: href});
    }

    const fireNavigationEvents = (path, pageName) => {

        if(!isEmbedMode) return;

        if(lessonListPath.test(path)) {
            postPageChangeEvent('lessonList', pageName);

        }else if(lessonPath.test(path)) {
            postPageChangeEvent('lesson', pageName);
        }
    }

    const value = {
        isEmbedMode,
        setEmbedMode,
        batch,
        setBatchData,
        fireNavigationEvents
    }

    return (
        <AppGlobalConfigContext.Provider value={value}>
            {children}
        </AppGlobalConfigContext.Provider>
    );
}

export function useAppGlobalConfig() {
    const context = useContext(AppGlobalConfigContext);
    if (!context) {
        throw new Error('useAppGlobalConfig must be used within an AppGlobalConfigProvider');
    }
    return context;
}